import React from "react";
import { Box, Typography } from "@mui/material";
import GenreTable from "./GenreTable";
import { ACTION, PERMISSIONS, usePermissions } from "../../../utils/permissions";

const GenreManagement = () => {
    const { hasPermission } = usePermissions();
    const canView =
        hasPermission(PERMISSIONS.genre, ACTION.VIEW) ||
        hasPermission(PERMISSIONS.genre, ACTION.EDIT);

    if (!canView) {
        return (
            <Box sx={{ p: 2 }}>
                <Typography variant="h6">Genre Management</Typography>
                <Typography sx={{ mt: 1 }}>
                    You don&apos;t have access to this module.
                </Typography>
            </Box>
        );
    }

    return (
        <div className="config-heading">
            <GenreTable />
        </div>
    );
};

export default GenreManagement;
